import React from "react";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP } from "./hcaData";
import { HcaReveal, scrollToForm } from "./HcaReveal";

export const HcaFinalCta = () => (
    <section data-testid="hca-final-cta-section" className="bg-[#0E1E3A] text-white">
        <HcaReveal className="max-w-5xl mx-auto px-6 py-20 text-center">
            <h2 className="font-display text-3xl sm:text-5xl leading-tight">
                Your caring career starts <span className="italic text-[#D4A140]">in 25 weeks.</span>
            </h2>
            <p className="text-white/70 mt-5 max-w-xl mx-auto">Speak with an admissions advisor today — it's free and there's no obligation.</p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                <button type="button" onClick={scrollToForm} data-testid="hca-final-cta-form-btn" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#D4A140] text-[#0E1E3A] px-7 py-3.5 font-semibold hover:bg-[#c08f33] transition-colors">
                    <ArrowUp className="h-4 w-4" /> Request program info
                </button>
                <a href={PHONE_TEL} data-testid="hca-final-cta-call-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-7 py-3.5 hover:bg-white/10 transition-colors">
                    <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
                </a>
                <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="hca-final-cta-whatsapp-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-7 py-3.5 hover:bg-white/10 transition-colors">
                    <MessageCircle className="h-4 w-4" /> WhatsApp
                </a>
            </div>
        </HcaReveal>
    </section>
);

export const HcaStickyBar = () => (
    <div data-testid="hca-sticky-mobile-bar" className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-[#D8DEE6] p-3 grid grid-cols-2 gap-2">
        <a href={PHONE_TEL} data-testid="hca-sticky-call-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-[#0E1E3A] py-2.5 text-sm font-semibold text-[#0E1E3A]">
            <Phone className="h-4 w-4" /> Call now
        </a>
        <button type="button" onClick={scrollToForm} data-testid="hca-sticky-form-btn" className="rounded-full bg-[#D4A140] py-2.5 text-sm font-semibold text-[#0E1E3A]">
            Get program info
        </button>
    </div>
);
